export const authReducer = (state = { admin: {} }, action) => {
  switch (action.type) {
    case "LOGIN_REQUEST":
      return {
        loading: true,
        isAuthenticated: false,
        admin: {},
      };
    case "LOGIN_SUCCESS":
      return {
        loading: false,
        isAuthenticated: true,
        admin: action.payload,
      };
    case "LOGIN_FAIL":
      return {
        loading: false,
        isAuthenticated: false,
        error: action.payload,
      };
    case "LOGOUT":
      return {
        loading: false,
        isAuthenticated: false,
        admin: {},
      };

    case "PAY_EXEC_LOGIN_REQUEST":
      return {
        loading: true,
        isAuthenticated: false,
        payment_executive: {},
      };
    case "PAY_EXEC_LOGIN_SUCCESS":
      return {
        loading: false,
        isAuthenticated: true,
        payment_executive: action.payload,
      };
    case "PAY_EXEC_LOGIN_FAIL":
      return {
        loading: false,
        isAuthenticated: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const forgotPassReducer = (state = {}, action) => {
  switch (action.type) {
    case "FORGOT_REQUEST":
    case "RESET_REQUEST":
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case "FORGOT_SUCCESS":
    case "RESET_SUCCESS":
      return {
        ...state,
        email: action.email,
        loading: false,
        success: true,
        message: action.payload,
      };
    case "FORGOT_FAIL":
    case "RESET_FAIL":
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case "PASS_RESET":
      return {
        ...state,
        success: false,
        error: null,
        message: null,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
